import styled from "@emotion/styled";

const PageWrapper = styled.div`
    /* overflow: hidden; */
   background-color: #000 !important;
   
`

export { PageWrapper }